<template>
    <div class="product-controls">
        <div v-if="includeDayLabels" class="product-controls__day-labels">
            <span v-for="day in basketStore.deliveryDays" :key="day" class="product-controls__day-label">
                {{ day.slice(0, 3) }}
            </span>
        </div>

        <div class="product-controls__quantities">
            <div v-for="day in basketStore.deliveryDays" :key="day" class="product-controls__quantity">
                <input class="product-controls__quantity-increment" type="button" value="▲" @click="quantityForDay(day).value++">
                <input class="product-controls__quantity-input" type="number" min="0" v-model="quantityForDay(day).value">
                <input class="product-controls__quantity-decrement" type="button" value="▼" @click="quantityForDay(day).value--">
            </div>
        </div>

        <div class="product-controls__actions-wrapper">
            <div v-if="includeClearButton" class="product-controls__actions">
                <button class="product-controls__clear" @click="clear">clear selection</button>
            </div>

            <div v-if="includeAddToQuoteButton" class="product-controls__actions">
                <button class="product-controls__add button button--1" @click="handleUpdateQuote" :disabled="subTotal < 0.01">update quote</button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { reactive, computed } from 'vue';
    import { useBasketStore } from './store';

    const basketStore = useBasketStore();

    const props = defineProps({
        purchasable: {
            type: Object,
            required: true
        },
        productUrl: {
            type: String,
            required: false,
            default: ''
        },
        includeDayLabels: {
            type: Boolean,
            required: false,
            default: false
        },
        includeClearButton: {
            type: Boolean,
            required: false,
            default: false
        },
        includeAddToQuoteButton: {
            type: Boolean,
            required: false,
            default: false
        },
        dynamicallyUpdateBasketStore: {
            type: Boolean,
            required: false,
            default: true
        }
    });

    const temporaryQuantities = reactive({});

    function quantityForDay(day) {
        return computed({
            get() {
                if (!props.purchasable) return 0;
                const item = basketStore.items.find(item => item.id === props.purchasable.id && item.deliveryDay === day);
                if (!props.dynamicallyUpdateBasketStore) {
                    if (temporaryQuantities[day] != null) {
                        return temporaryQuantities[day];
                    }
                    return item ? item.quantity : 0;
                }
                return item ? item.quantity : 0;
            },
            set(val) {
                if (!props.purchasable) return;
                const quantity = parseInt(val, 10) || 0;
                if (!props.dynamicallyUpdateBasketStore) {
                    temporaryQuantities[day] = quantity;
                    return;
                }
                if (quantity <= 0) {
                    basketStore.setItemQuantity({...props.purchasable, deliveryDay: day, quantity: 0});
                    // basketStore.removeItem(props.purchasable.id, day);
                    return;
                }
                basketStore.setItemQuantity({...props.purchasable, deliveryDay: day, quantity});
            }
        });
    }

    const applyTemporaryQuantitiesToBasket = () => {
        if (props.dynamicallyUpdateBasketStore) {
            return;
        }

        basketStore.deliveryDays.forEach(day => {
            const item = basketStore.items.find(item => item.id === props.purchasable.id && item.deliveryDay === day);
            const hasTemporary = temporaryQuantities[day] != null;

            if (!hasTemporary && !item) {
                return;
            }

            const quantity = hasTemporary ? temporaryQuantities[day] : item.quantity;
            basketStore.setItemQuantity({...props.purchasable, deliveryDay: day, quantity});
            if (hasTemporary) {
                delete temporaryQuantities[day];
            }
        });
    };

    const emitAddToBasketEvent = () => {
        const event = new CustomEvent('open-modal', {
            detail: { id: props.purchasable.name }
        });
        window.dispatchEvent(event);
    };

    const handleUpdateQuote = () => {
        applyTemporaryQuantitiesToBasket();
        emitAddToBasketEvent();
    };

    function clear() {
        basketStore.deliveryDays.forEach(day => {
            quantityForDay(day).value = 0;
        });
    }
</script>

<style scoped>
    button[disabled] {
        opacity: 0.4;
        cursor: not-allowed;
    }
</style>